import {Box, Grid, useMediaQuery, useTheme} from "@mui/material";
import {CancelButton} from "../buttons/CancelButton";
import React, {ReactNode} from "react";
import {SaveButton} from "../buttons/SaveButton";
import {SpecialMenu} from "../menu/SpecialMenu";
import {OutlinedEditButton} from "../buttons/OutlinedEditButton";
import {FormButtonBar} from "./FormButtonBar";
import {DeleteWithConfirmMenuEntry} from "../menu/DeleteWithConfirmMenuEntry";
import {DialogCloseButton} from "../dialogs/DialogCloseButton";

export function FormHeader(props: {
  title: string,
  onCancel: () => void,
  onDelete: () => void,
  readonly?: boolean,
  canBeEdited?: boolean,
  deleteIsDisabled?: boolean,
  onStartEditing?: () => void,
  additionalMenuEntry?: ReactNode,
  hideDialogControls?: boolean
}) {
  const theme = useTheme();
  const smallScreens = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Grid container={true}>
      <FormHeaderTitle title={props.title}/>
      {smallScreens && !props.hideDialogControls &&
        <DialogCloseButton onClose={props.onCancel}/>
      }
      <Grid item={true} xs={12} md={6} sx={{display: "flex", marginLeft: "auto"}}>
        <FormHeaderButtonBar title={props.title} onCancel={props.onCancel} onDelete={props.onDelete}
                             deleteIsDisabled={props.deleteIsDisabled} additionalMenuEntry={props.additionalMenuEntry}
                             canBeEdited={props.canBeEdited} onStartEditing={props.onStartEditing} readonly={props.readonly}/>
        {!smallScreens && !props.hideDialogControls &&
          <DialogCloseButton onClose={props.onCancel}/>
        }
      </Grid>
    </Grid>
  )
}

export function FormHeaderTitle(props: {
  title: string
}) {
  return (
    <Grid item={true} xs={8} md={6}>
      {/*We cannot use typography here because there seems to be a bug in mui that causes the theme to break*/}
      <Box component={'h4'} sx={{fontSize: 18, fontWeight: 'bolder', margin: 0}}>{props.title}</Box>
    </Grid>
  );
}

export function FormHeaderButtonBar(props: {
  title: string
  readonly?: boolean,
  onCancel: () => void,
  onDelete: () => void,
  canBeEdited?: boolean,
  deleteIsDisabled?: boolean,
  onStartEditing?: () => void,
  additionalMenuEntry?: ReactNode,
}) {
  return (
    <FormButtonBar sx={{width: 'fit-content', marginLeft: 'auto',}}>
      {!props.readonly &&
        <>
          <Grid item>
            <CancelButton onClick={props.onCancel}/>
          </Grid>
          <Grid item>
            <SaveButton/>
          </Grid>
        </>
      }
      {props.readonly && props.canBeEdited && (!props.deleteIsDisabled || props.additionalMenuEntry) &&
        <Grid item>
          <SpecialMenu>
            <DeleteWithConfirmMenuEntry onDelete={props.onDelete} title={props.title} disabled={props.deleteIsDisabled}/>
            {props.additionalMenuEntry}
          </SpecialMenu>
        </Grid>
      }
      {props.readonly && props.canBeEdited &&
        <Grid item>
          <OutlinedEditButton onClick={() => props.onStartEditing && props.onStartEditing()}/>
        </Grid>
      }
    </FormButtonBar>
  )
}
